import { templates } from '../data/templates';

/**
 * Merges a template preset into the current project draft.
 */
export function applyTemplateToDraft(template, currentDraft) {
  const newDraft = { ...currentDraft };
  const preset = template.preset;

  if (!preset) return newDraft;

  // Add template metadata to the draft
  newDraft.templateId = template.id;
  newDraft.templateName = template.name;

  for (const key in preset) {
    const draftValue = newDraft[key];
    const templateValue = preset[key];

    if (Array.isArray(templateValue)) {
      const existingArray = Array.isArray(draftValue) ? draftValue : [];
      newDraft[key] = [...new Set([...existingArray, ...templateValue])];
    } else if (typeof templateValue === 'boolean') {
      if (draftValue === undefined) {
        newDraft[key] = templateValue;
      }
    } else {
      if (!draftValue) {
        newDraft[key] = templateValue;
      }
    }
  }
  return newDraft;
}

/**
 * Finds a template by its ID.
 */
export function getTemplateById(id) {
  return templates.find(template => template.id === id);
}

/**
 * Lists all templates that belong to a specific category.
 */
export function listTemplatesByCategory(categoryId) {
  return templates.filter(template => template.applyTo === categoryId);
}